<template>
	<v-container fluid class="crm-index d-flex flex-column"
		:style="'height:'+$store.getters['general/availableHeight']+'px;'">
		<div class="d-flex align-center justify-end mb-2 flex-shrink-0">
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="$store.state.crm.loadingConversations"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.crm.conversations_count"
				:loading-info="$store.state.crm.loadingConversations"
				:showOrderBy="true"
				items-type="crms"
			/>
		</div>

		<div class="table-container flex-grow-1 pb-2">
			<v-data-table
				ref="table"
				:headers="headers"
				:items="$store.state.crm.conversations"
				item-key="id"
				:loading="$store.state.crm.loadingConversations"
				:server-items-length="$store.state.crm.conversations_count"
				:options.sync="options"
				loading-text="Cargando datos..."
				class="crm-table"
				:class="$vuetify.breakpoint.mobile ? '':'resizable'"
				disable-sort
				hide-default-header
				hide-default-footer
				@click:row="selectRow"
				:item-class="selectedRowClass"
				:footer-props="{
					itemsPerPageText: 'Filas por página',
					'items-per-page-options': itemsPerPageOptions
				}"
			>
				<template v-slot:header="{ props }" v-if="!$vuetify.breakpoint.mobile">
					<thead class="v-data-table-header">
						<tr>
							<th role="columnheader" scope="col" aria-label="#" class="header-cell"
								style="max-height: 30px; height: 25px;"
								:style="{ width: head.width ? head.width + 'px' : 'auto' }"
								:class="head.align == 'center' ? 'text-center':''"
								v-for="(head,index) in props.headers" :key="index"
								@mouseup="saveColumnWidth(index)"
							>
								<span>{{ head.text.toUpperCase() }}</span>
							</th>
						</tr>
					</thead>
				</template>
				<template v-slot:item.id="{ item }">
					<div>
						<div class="d-flex align-center">
							<p class="mb-1 mr-1 font-weight-bold">LP {{ item.project_line_info?.project_line?.number }}</p>
							<ProjectLineAssociationMenu :projectLineAssociations="item.associations" :btnClick="() => selectRow(item)"/>
						</div>
						<div class="d-flex align-center">
							<ProjectLineAssociationIcons :projectLineAssociations="item.associations" />
						</div>
					</div>
				</template>
				<template v-slot:item.user="{ item }">
					<div class="d-flex align-center">
						<div class="d-flex flex-column flex-grow-1">
							<b>{{ getUserName(item) }}</b>
							<div v-if="item.user && item.user.user">{{ item.user.user.email }}</div>
							<div v-else-if="item.user">{{ item.user.email }}</div>
							<div v-else>--</div>
						</div>
						<div class="d-flex flex-column align-self-center align-center justify-end ml-2">
							<UserAccountSelector :item="item"/>
							<v-tooltip bottom v-if="item.client?.company_profile && item.client?.accreditation?.status">
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="#FF1209"
										v-bind="attrs"
										v-on="on">mdi-domain</v-icon>
								</template>
								<span>Cliente Empresa</span>
							</v-tooltip>
							<v-tooltip bottom v-else>
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="#959595"
										v-bind="attrs"
										v-on="on">mdi-account</v-icon>
								</template>
								<span>Cliente Persona Natural</span> 
							</v-tooltip>
						</div>
					</div>
				</template>
				<template v-slot:item.project_detail="{ item }">
					<div class="py-1">
						<div class="d-flex align-start" style="gap: 8px; margin-bottom: 4px;">
							<p class="mb-0 flex-shrink-0" style="font-size: 10px; width: 80px;">Nombre:</p>
							<b class="flex-grow-1" style="white-space: normal; word-break: break-word; overflow-wrap: break-word; line-height: 1.3;">
								{{ item.project_info && item.project_info.project_detail ? item.project_info.project_detail : 'Sin registro' }}
							</b>
						</div>
						<div class="d-flex justify-space-between align-start" style="gap: 8px; margin-bottom: 4px;">
							<div class="d-flex align-start flex-grow-1" style="gap: 8px; min-width: 0;">
								<p class="mb-0 flex-shrink-0" style="font-size: 10px; width: 80px;">Dirección:</p>
								<div class="flex-grow-1" style="white-space: normal; word-break: break-word; overflow-wrap: break-word; line-height: 1.3; min-width: 0;">
									<b>{{ item.project_info ? item.project_info.address?.address : 'Sin registro' }}</b>
									<span v-if="item.project_info?.address?.district?.name">
										- {{ item.project_info.address.district.name }}
									</span>
									<span v-else>
										- Sin registro Comuna
									</span>
								</div>
							</div>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										x-small
										color="#524D4D"
										class="flex-shrink-0"
										@click.stop="() => { selectRow(item); openAddressModal(item) }"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon small dark>mdi-home-edit-outline</v-icon>
									</v-btn>
								</template>
								<span>Modificar Dirección</span>
							</v-tooltip>
						</div>
						<div class="d-flex align-start" v-if="item.project_info?.address?.rol" style="gap: 8px; margin-bottom: 4px;">
							<p class="mb-0 flex-shrink-0" style="font-size: 10px; width: 80px;">Rol:</p>
							<b class="flex-grow-1" style="white-space: normal; word-break: break-word; overflow-wrap: break-word; line-height: 1.3;">
								{{ item.project_info.address.rol }}
							</b>
						</div>

						<v-divider class="my-1"></v-divider>
						
						<div class="d-flex justify-space-between align-start" style="gap: 8px;">
							<div class="d-flex align-start flex-grow-1" style="gap: 8px; min-width: 0;">
								<p class="mb-0 flex-shrink-0" style="font-size: 10px; width: 80px;">Tipo Proyecto:</p>
								<b class="flex-grow-1" style="white-space: normal; word-break: break-word; overflow-wrap: break-word; line-height: 1.3; min-width: 0;">
									[{{ item.project_info?.project_type?.code }}] {{ item.project_info?.project_type?.name }}
								</b>
							</div>
							<ProjectTypeSelectorMenu
								v-if="$checkPermissions(['edit_crm'])"
								class="flex-shrink-0"
								:onClick="(project_type) => { selectRow(item); changeProjectType(item.id, project_type.id); }"
							/>
						</div>
					</div>
				</template>
				<template v-slot:item.message="{ item }">
					<div v-if="item.last_message">
						<b><small>{{ item.last_message.role == 1 ? 'Sistema':'Usuario' }}</small></b>
						<div style="max-width: 150px;">
							<div class="message-container" v-html="$options.filters.addTargetsToLinksMessages(item.last_message.message)"></div>
						</div>
					</div>
					<div v-else>
						<p class="mb-0 caption">No hay mensajes</p>
					</div>
				</template>
				<template v-slot:item.schedule="{ item }">
					<td class="pa-0">
						<ListingScheduleUnarchive :conversation="item" @selectRow="selectRow"/>
					</td>	
				</template>
				<template v-slot:item.responsible="{ item }">
					<td class="pa-2">
						<div>
							<b v-if="item.responsible?.profile">{{item.responsible?.profile?.name + ' ' + item.responsible?.profile?.lastname + ' ' + item.responsible?.profile?.second_lastname}}</b>
							<b v-else>--</b>
							<v-menu offset-y z-index="9999" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										dark
										small
										icon
										color="#524D4D"
										@click="selectRow(item)"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
									</v-btn>
								</template>
								<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
									<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
										<p class="caption mb-0 font-weight-bold white--text">Cambiar Responsable</p>
									</v-list-item>
									<v-list-item-group color="#524D4D">
										<v-list-item
											v-for="(responsible, index) in $store.state.users.usersList"
											:key="index"
											dense
											@click.stop="() => { selectRow(item); changeCRMResponsible(item, responsible.id) }"
										>
											<v-list-item-title dense>
												<div class="d-flex align-center">
													<img :src="responsible.profile.avatar" class="user-avatar mr-2" v-if="responsible?.profile?.avatar"/>
													<v-icon v-else class="user-avatar icon mr-2" color="#524D4D">mdi-account</v-icon>
													<div>
														<p class="mb-0">{{ responsible.profile?.name }} {{ responsible.profile?.lastname }} {{ responsible.profile?.second_lastname }}</p>
														<p class="mb-0 caption">{{ responsible.email }}</p>
													</div>
												</div>
											</v-list-item-title>
										</v-list-item>
									</v-list-item-group>
								</v-list>
							</v-menu>
						</div>
					</td>
				</template>
				<template v-slot:item.details="{ item }">
					<!-- <div><small>Tipo Proyecto:</small></div> -->
					<td class="pa-2">
						<b class="mr-2">{{ item.project_info?.project_type?.code }}</b>

						<v-menu offset-y z-index="9999" content-class="menu-bg-white" style="z-index: 9999; background-color: white;" v-if="$checkPermissions(['edit_crm'])">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									dark
									small
									icon
									color="#524D4D"
									@click="selectRow(item)"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
								</v-btn>
							</template>
							<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
								<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
									<p class="caption mb-0 font-weight-bold white--text">Cambiar Tipo de Proyecto</p>
								</v-list-item>
								<v-list-item-group color="#524D4D">
									<v-list-item
										v-for="(project_type, index) in $store.state.companies.companiesProjectTypes"
										:key="index"
										dense
										@click.stop="() => { selectRow(item); changeProjectType(item.id, project_type.id) }"
									>
										<v-list-item-title dense>
											{{ project_type.name }}
										</v-list-item-title>
									</v-list-item>
								</v-list-item-group>
							</v-list>
						</v-menu>
					</td>
				</template>
				<template v-slot:item.type="{ item }">
					<b>{{ item.mode == 1 ? 'Manual':'Automático' }}</b>
				</template>
				<template v-slot:item.created_at="{ item }">
					<td class="pa-2">
						<!-- <div><small>Tipo Proyecto:</small></div> -->
						<div><b>{{ item.created_at | toDateTime }}</b></div>
						<v-chip
							color="#524D4D"
							label
							outlined
							x-small
							class="px-1"
						>
							<b>{{ item.mode == 1 ? 'Manual':'Automático' }}</b>
						</v-chip>
						</td>
				</template>
				<template v-slot:item.actions="{ item }">
					<td class="pa-1">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									class="mx-1"
									icon
									dark
									x-small
									color="#959595"
									@click.stop="() => { selectRow(item); toConversationDetail(item) }"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon small dark>mdi-contacts-outline</v-icon>
								</v-btn>
							</template>
							<span>Ver Detalle</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									class="mx-1"
									icon
									:dark="!(sentEmailDiff(item) != -1 && sentEmailDiff(item) < 24)"
									x-small
									color="secondary"
									:disabled="sentEmailDiff(item) != -1 && sentEmailDiff(item) < 24"
									v-if="item.schedule"
									@click.stop="() => { selectRow(item); resendPaymentRequest(item) }"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon small dark>mdi-email</v-icon>
								</v-btn>
							</template>
							<span>Enviar Correo Solicitud de Pago</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									class="mx-1"
									icon
									dark
									x-small
									color="#524D4D"
									v-if="item.schedule"
									@click.stop="() => { selectRow(item); openBudgetModal(item) }"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon small dark>mdi-table-cog</v-icon>
								</v-btn>
							</template>
							<span>Gestionar Presupuesto</span>
						</v-tooltip>
						<v-tooltip bottom v-if="canReplicate(item)">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									dark
									x-small
									color="#524D4D"
									class="mx-1"
									v-bind="attrs"
									v-on="on"
									v-if="$checkPermissions(['edit_crm'])"
									@click.stop="() => { selectRow(item); replicateContactModal(item) }"
								>
									<v-icon small dark>mdi-content-duplicate</v-icon>
								</v-btn>
							</template>
							<span>Replicar</span>
						</v-tooltip>
						<v-tooltip bottom v-if="$checkPermissions(['delete_crm'])">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									dark
									x-small
									color="warning"
									class="mx-1"
									@click.stop="() => { selectRow(item); archiveCrm(item.id) }"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon small dark>mdi-archive-arrow-down-outline</v-icon>
								</v-btn>
							</template>
							<span>Archivar</span>
						</v-tooltip>
						<v-tooltip bottom v-if="$checkPermissions(['delete_crm'])">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									dark
									x-small
									color="error"
									class="mx-1"
									@click.stop="() => { selectRow(item); startRemoveCrm(item.id) }"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon small dark>mdi-delete-outline</v-icon>
								</v-btn>
							</template>
							<span>Eliminar</span>
						</v-tooltip>
						<v-tooltip bottom v-if="hasPreProjectAssociation(item)">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									dark
									x-small
									color="#524D4D"
									class="mx-1"
									v-bind="attrs"
									v-on="on"
									@click.stop="() => { selectRow(item); goToPreProject(item) }"
								>
									<v-icon small dark>mdi-information-variant-circle-outline</v-icon>
								</v-btn>
							</template>
							<span>Ver el PreProyecto Asociado</span>
						</v-tooltip>
						<v-tooltip bottom v-else>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									dark
									x-small
									color="#524D4D"
									class="mx-1"
									v-bind="attrs"
									v-on="on"
									@click.stop="() => { selectRow(item); toPreProjectsStart(item) }"
								>
									<v-icon small dark>mdi-send</v-icon>
								</v-btn>
							</template>
							<span>Pasar a PreProyecto</span>
						</v-tooltip>
					</td>
				</template>
			</v-data-table>
		</div>
		<!-- <div class="d-flex align-center justify-end mt-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.crm.conversations_count"
				:loading-info="$store.state.crm.loadingConversations"
				:showOrderBy="true"
				items-type="crms"
			/>
		</div> -->
	</v-container>
</template>

<script>
import moment from 'moment'
import _debounce from 'lodash/debounce'
import {sendScheduleEmail} from '@/helpers/api/conversations'
import {deleteCrmEntry, assignScheduleToUser, archiveCrmEntry, editCrmProjectType, editCrmResponsible} from '@/helpers/api/crm'
import {createBudget} from '@/helpers/api/budgets'
import {resizableGrid} from '@/helpers/resize-table'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'
import ProjectLineAssociationMenu from '@/components/Views/Projects/Parts/ProjectLineAssociationMenu'
import ProjectLineAssociationIcons from '@/components/Views/Projects/Parts/ProjectLineAssociationIcons'
import ProjectTypeSelectorMenu from '@/components/Helpers/Components/ProjectTypeSelectorMenu'
import UserAccountSelector from '@/components/Views/CRM/Sections/UserAccountSelector'
import ListingScheduleUnarchive from '@/components/Views/CRM/Sections/ListingScheduleUnarchive'

export default {
	name: 'CRMIndex',
	components: {
		DataTablePagination,
		ProjectLineAssociationMenu,
		ProjectLineAssociationIcons,
		ProjectTypeSelectorMenu,
		UserAccountSelector,
		ListingScheduleUnarchive
	},
	data() {
		return {
			search: '',
			selectedRowItem: null,
			searchInput: null,
			itemsPerPageOptions: [10, 25, 50, 100, 200],
      options: {
        page: 1,
        itemsPerPage: 50,
        order_by: localStorage.getItem('crms_order_by') ? parseInt(localStorage.getItem('crms_order_by')) : 1,
      },
			columnWidths: {}
		};
	},
	computed: {
		headers(){
			let headers = [
				{ text: 'Línea de Proyecto', value: 'id', width: '55px', sortable: false },
				{ text: 'Nombre', align: 'start', value: 'user', sortable: false },
				{ text: 'Proyecto', align: 'start', width: '250px', value: 'project_detail', sortable: false },
				{ text: 'Responsable', value: 'responsible', sortable: false },
				{ text: 'Estado Agenda / Desarchivo', value: 'schedule', sortable: false },
				{ text: 'Fecha Creación', align: 'start', value: 'created_at', sortable: false },
				{ text: 'Acciones', align: 'start', value: 'actions', sortable: false },
			]
			if(!this.$vuetify.breakpoint.mobile){
				const storedWidths = JSON.parse(localStorage.getItem('columnWidths')) || {};
				headers = headers.map((header) => {
					return {
						...header,
						width: storedWidths[header.value] || 'auto'
					}
				})
			}
			return headers.filter((header) => {
				return this.$store.state.crm.listingColumns[header.value]
			})
		},
		filteredUsers() {
			return this.$store.state.users.usersList.filter(user => {
				return (
					user.name.toLowerCase().includes(this.search.toLowerCase()) ||
					user.email.toLowerCase().includes(this.search.toLowerCase())
				);
			});
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		loadingConversations(){
			return this.$store.state.crm.loadingConversations
		}
	},
	watch: {
    options: {
      handler() {
				this.reloadInfo()
      },
      deep: true,
    },
		selectedCompany(newValue){
			if(newValue){
				this.reloadInfo()
				this.$store.dispatch('companies/getUserCompanyConnectedStatus')
				this.$store.dispatch('users/getUserFromCompany')
			}
		},
		loadingConversations(newValue){
			if(!newValue){
				this.$nextTick(() => {
					resizableGrid(this.$refs.table.$el)
				})
			}
		}
	},
	mounted(){
		if(this.selectedCompany){
			this.reloadInfo()
			this.$store.dispatch('companies/getUserCompanyConnectedStatus')
			this.$store.dispatch('users/getUserFromCompany')
		}
		const savedWidths = JSON.parse(localStorage.getItem('columnWidths'));
		if (savedWidths) {
			this.columnWidths = savedWidths;
		}
		const selectedRow = JSON.parse(localStorage.getItem('selected_crm_row'));
		if (selectedRow) {
			this.selectedRowItem = selectedRow
		}
		eventBus.$on('changeGeneralOrderList', this.onChangeGeneralOrderList)
    eventBus.$on('reloadInformation', this.debounceReloadInfo)
	},
	beforeDestroy() {
		eventBus.$off('changeGeneralOrderList', this.onChangeGeneralOrderList)
		eventBus.$off('reloadInformation', this.debounceReloadInfo)
	},
	methods: {
		onChangeGeneralOrderList(value){
			this.options.order_by = value
			this.debounceReloadInfo()
		},
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_crm_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		debounceReloadInfo: _debounce(function() { this.reloadInfo() }, 300),
		goToPreProject(item) {
			const preProjectAssociation = item?.associations?.associations?.find(
				assoc => assoc.morphable_type === 'App\\Models\\PreProject'
			);

			if (preProjectAssociation) {
				this.$store.commit('preprojects/setPreProjectModalId', preProjectAssociation.morphable_id);
			}
		},
		hasPreProjectAssociation(item) {
			const innerAssociations = item?.associations?.associations || [];
			return innerAssociations.some(
				assoc => assoc.morphable_type === 'App\\Models\\PreProject'
			);
		},
		getUserName(item) {
			const profile = item?.user?.user?.profile;
			const fallbackUser = item?.user;

			const name = profile
				? `${profile.name ?? ''} ${profile.lastname ?? ''} ${profile.second_lastname ?? ''}`.trim()
				: fallbackUser
				? `${fallbackUser.name ?? ''} ${fallbackUser.lastname ?? ''} ${fallbackUser.second_lastname ?? ''}`.trim()
				: 'No identificado';

			return name || 'No identificado';
		},
		userInfo(conversation){
			if(conversation.user){
				const user = conversation.user
				if(user && user.user && user.user.profile){
					return {
						name: user.user.profile.name,
						lastname: user.user.profile.lastname,
						second_lastname: user.user.profile.second_lastname,
						email: user.user.email,
						phone: user.user.profile.phone,
						account: true
					}
				}
				return {
					name: user.name,
					lastname: user.lastname,
					second_lastname: user.second_lastname,
					email: user.email,
					phone: user.phone,
				}
			}
			return null
		},
		canReplicate(conversation){
			const userInfo = this.userInfo(conversation)
			return userInfo && userInfo.name && userInfo.email
		},
		replicateContactModal(conversation){
			const userInfo = this.userInfo(conversation)
			const data = {
				user_name: userInfo.name,
				lastname: userInfo.lastname,
				second_lastname: userInfo.second_lastname,
				user_email: userInfo.email,
				user_phone: userInfo.phone,
				project_detail: conversation.project_info?.project_detail,
				address: conversation.project_info?.address?.address,
				coordinates: conversation.project_info?.address?.coordinates,
				project_type_id: conversation.project_info?.project_type?.id,
				disable_user: true
			}
			this.$store.commit('crm/setNewContactModalData', data)
			this.$store.commit('crm/setNewContactModal', true)
		},
		openAddressModal(item){
			const project_info = item.project_info
			const address = project_info?.address
			const data = {
				status: true,
				edit: {...address, ...{crm_id: item.id, address_id: address?.id, coordinates: null}}
			}
      this.$store.commit('general/setAddressModal', data)
		},
		async openBudgetModal(crm){
			let budget = crm.budget
			if(!budget){
				const budgetCreate = await createBudget({
					item_type: 'crm',
					item_id: crm.id
				})
				if(budgetCreate.code == 200){
					budget = budgetCreate.budget
				}
			}

			localStorage.setItem('last_working_budget', JSON.stringify(budget))
			this.$router.push({ name: 'BudgetDetail', query: { id: budget.id } })
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.reloadInfo()
		},
		toPreProjectsStart(crm){
			if(crm.user && ( crm.user.user_id || crm.user.email )){
				const preproject_info = {
					crm_id: crm.id,
					client_id: crm.user.user_id,
					name: crm.project_info?.project_detail
				}
				localStorage.setItem('new_preproject_info', JSON.stringify(preproject_info));
				this.$store.commit('preprojects/setNewPreProjectModal', true)
			}
			else{
				const data = {
					message: 'No se encontraron datos suficientes para crear al usuario. Por favor edita los datos del usuario para continuar.',
					title: 'Datos Insuficientes',
					created: new Date(),
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.$store.dispatch('general/addMessage', data)
			}
		},
		saveColumnWidth(index) {
			const header_value = this.headers[index].value
			const headerCell = this.$refs.table.$el.querySelectorAll('.header-cell')[index];
			const newWidth = headerCell.offsetWidth;
			this.$set(this.columnWidths, header_value, newWidth);
			localStorage.setItem('columnWidths', JSON.stringify(this.columnWidths));
		},
		async changeProjectType(conversation_id, project_type_id){
			await editCrmProjectType({conversation_id, project_type_id})
			this.reloadInfo()
		},
		startRemoveCrm(crm_id){
			const confirmation = confirm("¿Estás seguro que quieres eliminar el registro?")
			if(confirmation){
				this.removeCrm(crm_id)
			}
		},
		async removeCrm(crm_id){
			await deleteCrmEntry({crm_id})
			this.reloadInfo()
		},
		async resendPaymentRequest(conversation){
			try {
				await sendScheduleEmail({schedule_id: conversation.schedule.id})
				const data = {
					message: 'El correo con la solicitud de pago ha sido enviado al usuario.',
					title: 'Correo enviado correctamente',
					created: new Date(),
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3'
				}
				this.$store.dispatch('general/addMessage', data)
				this.reloadInfo()
			} catch {
				const data = {
					message: 'Por favor intenta nuevamente.',
					title: 'Error al enviar el correo',
					created: new Date(),
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.$store.dispatch('general/addMessage', data)
			}
		},
		sentEmailDiff(conversation){
			if(conversation.schedule && conversation.schedule.request_email.length > 0){
				const current = moment()
				const startTime = conversation.schedule.request_email[0].created_at
				var duration = moment.duration(current.diff(startTime))
				var hours = duration.asHours()
				return hours
			}
			else if(conversation.schedule.request_email.length == 0){
				return -1
			}
			return null
		},
		addUser() {
			this.$store.commit('users/setNewUserModal', true)
		},
		toConversationDetail(conversation) {
			this.$router.push({ name: 'Conversation', params: { id: conversation.id } })
		},
		editUser(user) {
			alert(`Editar usuario: ${user.name}`);
		},
		deleteUser(user) {
			const index = this.users.indexOf(user);
			if (index > -1) {
				this.users.splice(index, 1);
			}
		},
		async archiveCrm(crm_id){
			await archiveCrmEntry({crm_id})
			this.reloadInfo()
		},
		reloadInfo(){
			let data = {
				...this.options,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
			}
			if(this.searchInput){
				data = {...data, ...{search: this.searchInput}}
			}
			this.$store.dispatch('crm/getConversations', data)
		},
		async changeCRMResponsible(item, responsible_id){
			const data = {
				conversation_id: item.id,
				responsible_id
			}
			await editCrmResponsible(data)
			this.reloadInfo()
		},
		async changeUserAssignation(item, new_user_id){
			await assignScheduleToUser({new_user_id, schedule_id: item.schedule.user_schedule.id})
			this.reloadInfo()
		},
	},
};
</script>
<style>
	.crm-index {
		padding-bottom: 0 !important;
		overflow: hidden;
	}

	.table-container {
		position: relative;
		min-height: 0;
		overflow: hidden;
	}

	.table-container .v-data-table {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.table-container .v-data-table__wrapper {
		overflow-y: auto !important;
		overflow-x: auto !important;
		flex: 1;
	}

	.crm-index .message-container {
		margin-bottom: 0;
		font-size: 12px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.crm-index .message-container p {
		margin-bottom: 0;
		font-size: 12px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.crm-table table tr td {
		font-size: 11px!important;
	}

	.crm-table.resizable .v-data-table__wrapper th,
	.crm-table.resizable .v-data-table__wrapper td {
		border-right: 1px solid #cacaca;
	}
</style>

<style scoped>
	.menu-bg-white {
		background: white;
	}
</style>